import React, { useContext, useEffect, useState, createContext } from "react"

import { getSubscriptions, unsubscribe  } from '@portal/kit/pkg/services'
import { EndUserContext } from "@portal/kit/pkg/components"

export const SubscriptionContext = createContext()

export default function SubscriptionProvider({ children }) {
  const [subscriptions, setSubscriptions] = useState([])
  const { data: user } = useContext(EndUserContext)

  useEffect(() => {
    if (!user) return

    fetchSubscriptions()
  }, [user])

  const fetchSubscriptions = async () => {
    try {
      const response = await getSubscriptions()
      setSubscriptions(response.data.subscriptions)
    } catch (error) {
      console.log(error)
    }
  }

  const unsubscribeSubscription = async (id, ends_at) => {
    try {
      await unsubscribe(id, ends_at.toString())
      fetchSubscriptions()
      return { success: true }
    } catch (e) {
      return { error: e.response.data.error, success: false }
    }
  }

  return (
    <SubscriptionContext.Provider value={{
      subscriptions,
      unsubscribeSubscription
    }}>
      {children}
    </SubscriptionContext.Provider>
  )
}
